import baseAPI from '@/api';
import { CreateBettingSessionInputDto } from '@/services/dto/betiing-session/create-betting-session-input.dto';
import { DetailedBettingSession } from '@/models/betting-session/detailed';
import { AxiosResponse } from 'axios';

export async function fetchCreateBettingSession(
  data: CreateBettingSessionInputDto,
): Promise<DetailedBettingSession> {
  const response: AxiosResponse<DetailedBettingSession> =
    await baseAPI.post<DetailedBettingSession>('betting-sessions', data);

  return response.data;
}
